import React, { useContext, useEffect, useState } from 'react';
import { MdOutlineEdit, MdOutlineDelete } from 'react-icons/md';

import * as S from './styles';
import Modal from 'components/Modal';
import { Collection } from 'types/BannerPlpProps';
import AddBtn from 'components/AddBtn';
import SimpleInput from 'components/SimpleInput';
import SystemNotifyContext from 'context/SystemNotifyContext';
import { generateUid, shrinkText } from 'utils/functions';

interface CollectionWithId extends Collection {
	idFront: string;
}

interface AddCollectionsProps {
	collections: Collection[];
	setCollections: any;
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const initialCollection: CollectionWithId = {
	idFront: '',
	idCollection: '',
	idProvider: ''
};

export default function AddCollections({
	isOpen,
	setIsOpen,
	collections,
	setCollections
}: AddCollectionsProps) {
	const { handleNotify } = useContext(SystemNotifyContext);

	const [modalAdd, setModalAdd] = useState(false);
	const [editMode, setEditMode] = useState(false);
	const [collection, setCollection] = useState<CollectionWithId>({
		...initialCollection,
		idFront: generateUid()
	});
	const [collectionsIntern, setCollectionsIntern] = useState<
		CollectionWithId[]
	>([]);

	function addCollectionOnList(collection: CollectionWithId) {
		if (collection.idCollection === '') {
			handleNotify("Preencha o campo 'Id da coleção'", 'error');
			return;
		}

		if (collection.idProvider === '') {
			handleNotify("Preencha o campo 'Id do distribuidor'", 'error');
			return;
		}

		const idCollectionExists = collectionsIntern.some(
			(item) => item.idCollection === collection.idCollection
		);

		if (idCollectionExists) {
			handleNotify('Este Id da coleção já existe na lista', 'error');
			return;
		}

		const idProviderExists = collectionsIntern.some(
			(item) => item.idProvider === collection.idProvider
		);

		if (idProviderExists) {
			handleNotify('Este Id do distribuidor já existe na lista', 'error');
			return;
		}

		if (editMode) {
			const newList = collectionsIntern.map((item) => {
				if (item.idFront === collection.idFront) {
					return collection;
				}
				return item;
			});
			setCollectionsIntern(newList);
		} else {
			setCollectionsIntern((prev) => [...prev, collection]);
		}

		setModalAdd(false);
		setCollection({ ...initialCollection, idFront: generateUid() });
		setEditMode(false);
	}

	function deleteCollection(idCollection: string) {
		const newList = collectionsIntern.filter(
			(item) => item.idCollection !== idCollection
		);
		setCollectionsIntern(newList);
	}

	function resetStates() {
		setCollection(initialCollection);
		setCollectionsIntern([]);
		setModalAdd(false);
		setEditMode(false);
	}

	function saveListOnFather() {
		if (collectionsIntern.length === 0) {
			handleNotify('Insira pelo menos 1 coleção', 'error');
			return;
		}
		const newList: Collection[] = collectionsIntern.map((item) => ({
			idCollection: item.idCollection,
			idProvider: item.idProvider
		}));

		setCollections(newList);
		resetStates();
		setIsOpen(false);
	}

	function editCollection(collection: CollectionWithId) {
		setEditMode(true);
		setModalAdd(true);
		setCollection(collection);
	}

	useEffect(() => {
		const newList: CollectionWithId[] = collections.map((item) => {
			const newItem: CollectionWithId = { ...item, idFront: generateUid() };
			return newItem;
		});

		setCollectionsIntern(newList);
	}, [collections]);

	return (
		<Modal
			isOpenProps={isOpen}
			setIsOpenModal={() => {
				setIsOpen(false);
			}}
			title={'Coleções'}
			buttonClose={false}
		>
			<S.container>
				<AddBtn
					anyFunction={() => {
						setModalAdd(true);
					}}
					text="Adicionar coleção"
				/>

				{collectionsIntern.length === 0 ? (
					<S.noData>
						<p>Não há coleções cadastradas</p>
					</S.noData>
				) : (
					<S.list>
						{collectionsIntern.map((collection, i: number) => (
							<S.itemList key={i}>
								<S.infos>
									<p>
										<b>Id Coleção:</b> {shrinkText(collection.idCollection, 10)}
									</p>
									<p>
										<b>ID Distribuidor:</b>{' '}
										{shrinkText(collection.idProvider, 10)}
									</p>
								</S.infos>

								<S.controls>
									<MdOutlineEdit
										onClick={() => {
											editCollection(collection);
										}}
									/>
									<MdOutlineDelete
										onClick={() => {
											deleteCollection(collection.idCollection);
										}}
									/>
								</S.controls>
							</S.itemList>
						))}
					</S.list>
				)}

				{modalAdd && (
					<Modal
						isOpenProps={modalAdd}
						setIsOpenModal={setModalAdd}
						title={'Coleções'}
						buttonClose={false}
					>
						<S.form>
							<SimpleInput
								label="Id da coleção"
								initialValue={collection?.idCollection}
								getValue={(value: string) => {
									setCollection((obj) => ({
										...obj,
										idCollection: value
									}));
								}}
							/>

							<SimpleInput
								label=" Id do distribuidor"
								initialValue={collection?.idProvider}
								getValue={(value: string) => {
									setCollection((obj) => ({
										...obj,
										idProvider: value
									}));
								}}
							/>

							<S.containerBtns>
								<S.cancel
									onClick={() => {
										setModalAdd(false);
									}}
								>
									Cancelar
								</S.cancel>
								<S.save
									data-testid="saveBtn"
									onClick={() => {
										addCollectionOnList(collection);
									}}
								>
									Salvar
								</S.save>
							</S.containerBtns>
						</S.form>
					</Modal>
				)}

				<S.containerBtns>
					<S.cancel
						onClick={() => {
							setIsOpen(false);
						}}
					>
						Cancelar
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={() => {
							saveListOnFather();
						}}
					>
						Salvar
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
